module.exports = __webpack_public_path__ + "img/latest_block_default.0c488b1d.png";